import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { useRouter } from "next/navigation";
import React, { useEffect } from "react";
import styles from "@/components/modal/license-limited-modals/styles/license-limited-modal.module.scss";
import IncreaseLimitsButton from "@/components/common/increase-limits-button";
import { LicenseName } from "@/data/license.data";
import FilledButton from "@/components/common/filled-button";
import Link from "next/link";
import GetFreeAccessButton from "@/components/common/get-free-access-button";

type Props = {
  licenseName: LicenseName;
};

const CustomVoicesLimitedModal = ({ licenseName }: Props) => {
  const { hideModal } = useGlobalModalContext();
  const router = useRouter();
  useEffect(() => {
    router.push("/pricing");
  }, [router]);

  return (
    <div className={styles.trial_modal}>
      <div className={styles.main_text}>
        Thank you for using <br /> {licenseName.toLowerCase()} version of
        AudioModify!
      </div>
      {licenseName !== "Trial" && (
        <div className={styles.sub_container}>
          <div>
            To use custom voices, please upgrade to higher plan to increase
            amount of available voice slots.
          </div>
        </div>
      )}
      <div className={styles.please_upgrade}>
        Please upgrade to the paid version to create custom voices, generate
        unlimited number of AI covers and more!
        <br />
        30% off only today with discount code &quot;cover&quot;
      </div>
      <GetFreeAccessButton />
      {licenseName === "Trial" ? (
        <Link href={"/pricing"}>
          <FilledButton text={"UPGRADE"} onClick={hideModal} />
        </Link>
      ) : (
        <IncreaseLimitsButton filled={true} onClick={hideModal} />
      )}
    </div>
  );
};

export default CustomVoicesLimitedModal;
